import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-nps-rating',
  templateUrl: './nps-rating.component.html',
  styleUrls: ['./nps-rating.component.scss'],
})
export class NpsRatingComponent {

  @Input() rate = 0;

  @Output() didRated = new EventEmitter<number>();


  constructor() { }
}
